// @ts-nocheck
// fetch all clients
export const FETCH_ALL_CLIENTS_REQUEST = "FETCH_ALL_CLIENTS_REQUEST";
export const FETCH_ALL_CLIENTS_SUCCESS = "FETCH_ALL_CLIENTS_SUCCESS";
export const FETCH_ALL_CLIENTS_FAILURE = "FETCH_ALL_CLIENTS_FAILURE";

// update a client
export const UPDATE_CLIENT_REQUEST = "UPDATE_CLIENT_REQUEST";
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS";
export const UPDATE_CLIENT_FAILURE = "UPDATE_CLIENT_FAILURE";

// delete a client
export const DELETE_CLIENT_REQUEST = "DELETE_CLIENT_REQUEST";
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";
export const DELETE_CLIENT_FAILURE = "DELETE_CLIENT_FAILURE";

// create a client
export const CREATE_CLIENT_REQUEST = "CREATE_CLIENT_REQUEST";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const CREATE_CLIENT_FAILURE = "CREATE_CLIENT_FAILURE";

// toggle client status
export const TOGGLE_CLIENT_STATUS_REQUEST = "TOGGLE_CLIENT_STATUS_REQUEST";
export const TOGGLE_CLIENT_STATUS_SUCCESS = "TOGGLE_CLIENT_STATUS_SUCCESS";
export const TOGGLE_CLIENT_STATUS_FAILURE = "TOGGLE_CLIENT_STATUS_FAILURE";

// search clients
export const SEARCH_CLIENTS_REQUEST = "SEARCH_CLIENTS_REQUEST";
export const SEARCH_CLIENTS_SUCCESS = "SEARCH_CLIENTS_SUCCESS";
export const SEARCH_CLIENTS_FAILURE = "SEARCH_CLIENTS_FAILURE";

//Approve client
export const APPROVE_CLIENT_TOGGLE_REQUEST = "APPROVE_CLIENT_TOGGLE_REQUEST";
export const APPROVE_CLIENT_TOGGLE_SUCCESS = "APPROVE_CLIENT_TOGGLE_SUCCESS";
export const APPROVE_CLIENT_TOGGLE_FAILURE = "APPROVE_CLIENT_TOGGLE_FAILURE";

// fetch all companies
export const FETCH_ALL_COMPANIES_REQUEST = "FETCH_ALL_COMPANIES_REQUEST";
export const FETCH_ALL_COMPANIES_SUCCESS = "FETCH_ALL_COMPANIES_SUCCESS";
export const FETCH_ALL_COMPANIES_FAILURE = "FETCH_ALL_COMPANIES_FAILURE";

// fetch all active clients
export const FETCH_ALL_ACTIVE_CLIENTS_REQUEST =
  "FETCH_ALL_ACTIVE_CLIENTS_REQUEST";
export const FETCH_ALL_ACTIVE_CLIENTS_SUCCESS =
  "FETCH_ALL_ACTIVE_CLIENTS_SUCCESS";
export const FETCH_ALL_ACTIVE_CLIENTS_FAILURE =
  "FETCH_ALL_ACTIVE_CLIENTS_FAILURE";